const LABELS: Record<string, string> = {
  ICE: "Бензин/Дизель",
  HEV: "Hybrid",
  PHEV: "Plug-in Hybrid",
  EV: "Electric",
};

export function PowertrainBadge({ type }: { type: string }) {
  const cls = type === "HEV" || type === "PHEV" ? "badge badge-hev" : type === "EV" ? "badge badge-ev" : "badge badge-ice";
  return <span className={cls}>{LABELS[type] ?? type}</span>;
}
